import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose, withState } from 'recompose';

import { Loading } from 'components/Loading';

import { Title, Modal, Button, Flexer, Radios, Spacer } from '@ontruck/orc';

import { cancellationQuote } from 'redux/modules/shipper-order-edit/effects';

import { getCancellationQuote } from 'redux/modules/shipper-order-edit/selectors';

import { SummarySection } from 'modules/shipper-order/Form/sections';
import { SummarySection as CostSummarySection } from 'modules/journey/EditForm/sections';

import { StyledBordered } from './styled';

const cancellationAmountStatuses = {
  PENDING_MODERATION: 0,
  PENDING_ASSIGNMENT: 0,
  ASSIGNED: 0,
  PENDING_PICKUP: 0,
  LOADED: 100,
  notFound: 100,
};

class CancelShipperOrderModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    cancellationValues: PropTypes.array,
    values: PropTypes.object,
    showCarrierSection: PropTypes.bool,
    onSubmit: PropTypes.func,
    shipperOrder: PropTypes.object,
    cancellationQuote: PropTypes.func,
    quote: PropTypes.object,
    setValue: PropTypes.func,
    currency: PropTypes.string,
  };

  static defaultProps = {
    showCarrierSection: true,
  };

  constructor(props) {
    super(props);
    this.handleQuote = this.handleQuote.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const { onSubmit, shipperOrder, values } = this.props;

    const { price, cost } = values;

    onSubmit(shipperOrder, {
      price,
      cost,
    });
  }

  componentDidMount() {
    this.handleQuote();
  }

  handleQuote() {
    const { shipperOrder, cancellationQuote, values } = this.props;

    const { price, cost } = values;

    cancellationQuote(shipperOrder, {
      price,
      cost,
    });
  }

  render() {
    const {
      show,
      onClose,
      cancellationValues,
      showCarrierSection,
      quote,
      setValue,
      values,
      currency,
      intl,
    } = this.props;
    const t = intl.messages.modules.shipper_order.cancelModal;
    const Selector = ({ type }) => (
      //niapaton
      <div>
        <Radios
          value={Math.abs(values[type])}
          size="M"
          legend=""
          items={cancellationValues.map((item, i) => ({
            value: item,
            label: `${item} % - ${t.values_literals[i]}`,
          }))}
          disabled={loading}
          onChange={(e, { value }) => {
            setValue(
              {
                price: values.price,
                cost: values.cost,
                [type]: value,
              },
              this.handleQuote
            );
          }}
        />
      </div>
    );

    const { loading } = quote;

    return (
      <Modal
        show={show}
        onClose={onClose}
        size={showCarrierSection ? 'L' : 'M'}
        headerComponent={t.title}
        withPadding={false}
      >
        <Spacer p="M" pTop="N">
          <Flexer.Parent mBottom="M">
            <StyledBordered
              flex="1"
              pTop="M"
              pRight={showCarrierSection ? 'M' : 'N'}
              showBorder={showCarrierSection}
            >
              <Title text={t.price_title} size="XL" level="h3" mBottom="S" />
              {<Selector type="price" />}
              {!loading && quote.ready && (
                <SummarySection currency={currency} quote={quote.price} summaryType="price" />
              )}
            </StyledBordered>
            {!!showCarrierSection && (
              <Flexer.Child flex="1" pTop="M" pLeft="M">
                <Title text={t.cost_title} size="XL" level="h3" mBottom="S" />
                {!loading && quote.ready && (
                  <CostSummarySection currency={currency} quote={quote.cost} summaryType="cost" />
                )}
              </Flexer.Child>
            )}
          </Flexer.Parent>
          {loading && (
            <Spacer mBottom="M">
              <Loading />
            </Spacer>
          )}
          <Button disabled={loading} onClick={this.handleSubmit}>
            {t.apply_change}
          </Button>
          <Button nude skin="secondary" onClick={onClose}>
            {t.do_not_cancel}
          </Button>
        </Spacer>
      </Modal>
    );
  }
}

const actionCreators = {
  cancellationQuote,
};

export default compose(
  injectIntl,
  connect(
    (state) => ({
      quote: getCancellationQuote(state),
    }),
    actionCreators
  ),
  withState('values', 'setValue', ({ shipperOrder }) => {
    const cancellationAmount =
      typeof cancellationAmountStatuses[shipperOrder.status] !== 'undefined'
        ? cancellationAmountStatuses[shipperOrder.status]
        : cancellationAmountStatuses.notFound;
    return {
      price: cancellationAmount,
      cost: cancellationAmount,
    };
  })
)(CancelShipperOrderModal);
